import { t } from "@/i18n-js/instance";
import type { ChatRoomMessage } from "@/react/types/Chat/ChatRoomMessage";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { useChatMessages, useParticipants } from "../../hooks";
import { useSignInUrl } from "../../hooks/useSignInUrl";
import { MessageItem } from "./MessageItem";
import { useChatContainerBehavior } from "./hooks/useChatContainerBehavior";

export const Chat = () => {
  const { messages, isLoading: isMessagesLoading } = useChatMessages();
  const { participants, isLoading: isParticipantsLoading } = useParticipants();
  const { chatContainerRef, onScroll } = useChatContainerBehavior({ messages });
  const { canSignIn, redirectToUrl: redirectToSignIn } = useSignInUrl();

  if (isMessagesLoading || isParticipantsLoading) {
    return <Loader center />;
  }

  return (
    <div
      ref={chatContainerRef}
      onScroll={onScroll}
      className="mb-6 mt-3 flex grow flex-col items-stretch justify-between overflow-auto px-6"
    >
      <div id="messages-container">
        {messages.map((message: ChatRoomMessage) => (
          <MessageItem
            message={message}
            key={message.id}
            participants={participants}
          />
        ))}
      </div>
      {canSignIn && (
        <div className="bg-secondary flex h-11 w-full shrink-0 items-center justify-center rounded-md">
          <button type="button" onClick={redirectToSignIn} className="mr-1">
            <Typography.LabelSm as="span" weight="semibold">
              {t("public_live_stream.login")}
            </Typography.LabelSm>
          </button>
          <Typography.LabelSm>
            {t("public_live_stream.to_chat")}
          </Typography.LabelSm>
        </div>
      )}
    </div>
  );
};
